import * as React from 'react';

import * as PropTypes from 'prop-types';

import env from '../env';
import {
  capitalizeFirstLetter,
  obfuscatePhoneNumber,
} from '../helpers/stringUtils';
import icons from '../icons';
import {
  FeatureFlag,
  Recipient,
  UserSession,
} from '../types';

interface HeaderProps {
    leftAction?: any;
    leftContent?: any;
    leftLabel?: string | JSX.Element;
    recipient?: Recipient;
    rightAction?: any;
    rightContent?: any;
    rightLabel?: string | JSX.Element;
    session?: UserSession;
    title?: string;
    titleAction?: () => void;
}

const renderLeftContent = (leftContent, leftLabel, leftAction) => {
    if (!leftContent && !leftLabel) {
        return null;
    }

    if (leftContent) {
        return leftContent;
    }

    return (
        <div className="header__button">
            <a onClick={leftAction}>{leftLabel}</a>
        </div>
    );
};

const renderRightContent = (rightContent, rightLabel, rightAction, children) => {
    if (!rightContent && !rightLabel) {
        return null;
    }

    if (rightContent === 'renderChildren') {
        return children;
    }

    if (rightContent) {
        return rightContent;
    }

    return (
        <div className="header__button">
            <a onClick={rightAction}>{rightLabel}</a>
        </div>
    );
};

const renderTitle = (session, title, titleAction, recipient, onDesktop) => {
    if (title) {
        const dealerLogoUrl = session && session.dealer.logo ? env.WEBAPP_HOST + 'template/images/dealer/' + session.dealer.logo : null;
        const dealerTitle = session && dealerLogoUrl && session.features.includes(FeatureFlag.CUSTOM_BRANDING)
            ? (
                <div className="header__title">
                    <img className="header__logo" src={dealerLogoUrl} alt={session.dealer.name}/>
                </div>
            )
            : (
                <div className="header__title">{title}</div>
            );

        return titleAction
            ? (<div onClick={titleAction}>{dealerTitle}</div>)
            : dealerTitle;
    }

    if (recipient) {
        const recipientTitle = (
            <div className="header__title header__title-customerName">
                {!recipient.name
                    ? obfuscatePhoneNumber(recipient.unit_number)
                    : capitalizeFirstLetter(recipient.name)
                }
                {!onDesktop ? icons.chevronDown : null}
            </div>
        );

        return titleAction
            ? (<div onClick={titleAction}>{recipientTitle}</div>)
            : recipientTitle;
    }
};

const Header: React.StatelessComponent<HeaderProps> = ({ recipient, session, title, titleAction, rightAction, rightLabel, rightContent, leftAction, leftLabel, leftContent, children }, { onDesktop }) => {
    return (
        <div className="header">
            <div className="header__button-left">
                {renderLeftContent(leftContent, leftLabel, leftAction)}
            </div>

            {renderTitle(session, title, titleAction, recipient, onDesktop)}

            <div className="header__button-right">
                {renderRightContent(rightContent, rightLabel, rightAction, children)}
            </div>
        </div>
    );
};

Header.contextTypes = {
    onDesktop: PropTypes.bool
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.tsx